export const TREATMENT_CATEGORIES_IDS = {
  Hairloss: '9',
  Acne: '11',
  Diet: '12',
};
